import { render, staticRenderFns } from "./serviceDetails.vue?vue&type=template&id=8618aefe"
import script from "./serviceDetails.vue?vue&type=script&lang=js"
export * from "./serviceDetails.vue?vue&type=script&lang=js"
import style0 from "./serviceDetails.vue?vue&type=style&index=0&id=8618aefe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports